import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import CTASection from '../components/sections/CTASection';
import PricingPreview from '../components/sections/PricingPreview';
import { useTranslation } from '../hooks/useTranslation';
import { useSEO } from '../hooks/useSEO';

const MobileProxiesPage = () => {
  const { t } = useTranslation();
  useSEO('mobile-proxies'); 

  const features = t('proxies.mobile.features.list', { returnObjects: true });
  
  const featuresList = Array.isArray(features) ? features : [];

  const featuresWithIcons = featuresList.map((f, i) => ({
    ...f,
    icon: ['Smartphone', 'Zap', 'Shield', 'Globe'][i % 4]
  }));

  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <HeroSection 
          title1={t('proxies.mobile.hero.title1')}
          title2={t('proxies.mobile.hero.title2')}
          subtitle={t('proxies.mobile.hero.subtitle')}
        />
        <FeaturesSection 
          title={t('proxies.mobile.features.title')}
          subtitle={t('proxies.mobile.features.subtitle')}
          features={featuresWithIcons}
        />
        <PricingPreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default MobileProxiesPage;
